var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScaleViewer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "960px",
    height: "32px",
    viewBox: "0 0 960 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer_svg__\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer_svg__\\u753B\\u677F",
    transform: "translate(-104.000000, -175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer_svg__\\u7F16\\u7EC4-10\\u5907\\u4EFD",
    transform: "translate(104.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer_svg__\\u7F16\\u7EC4-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer_svg__\\u7F16\\u7EC4-15"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 12,
    x2: 59,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-3",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: 18,
    x2: 74,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-6",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 18,
    x2: 135,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-9",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 18,
    x2: 195,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-24",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 18,
    x2: 29,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-4",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: 18,
    x2: 89,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-7",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 18,
    x2: 150,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-10",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 18,
    x2: 210,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-26",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 18,
    x2: 44,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-5",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 18,
    x2: 104,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 18,
    x2: 165,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-11",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225,
    y1: 18,
    x2: 225,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-27",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.5,
    x2: 0.5,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-2",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 12,
    x2: 120,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 12,
    x2: 180,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-28",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "scale-viewer_svg__1",
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontSize: 10,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 11
  }, "1"))), /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer_svg__\\u7F16\\u7EC4-15\\u5907\\u4EFD-2",
    transform: "translate(480.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 12,
    x2: 59,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-3",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: 18,
    x2: 74,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-6",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 18,
    x2: 135,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-9",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 18,
    x2: 195,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-24",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 18,
    x2: 29,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-4",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: 18,
    x2: 89,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-7",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 18,
    x2: 150,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-10",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 18,
    x2: 210,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-26",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 18,
    x2: 44,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-5",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 18,
    x2: 104,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 18,
    x2: 165,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-11",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225,
    y1: 18,
    x2: 225,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-27",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.5,
    x2: 0.5,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-2",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 12,
    x2: 120,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 12,
    x2: 180,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-28",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "scale-viewer_svg__3",
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontSize: 10,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 11
  }, "3"))), /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer_svg__\\u7F16\\u7EC4-15\\u5907\\u4EFD",
    transform: "translate(240.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 12,
    x2: 59,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-3",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: 18,
    x2: 74,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-6",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 18,
    x2: 135,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-9",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 18,
    x2: 195,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-24",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 18,
    x2: 29,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-4",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: 18,
    x2: 89,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-7",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 18,
    x2: 150,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-10",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 18,
    x2: 210,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-26",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 18,
    x2: 44,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-5",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 18,
    x2: 104,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 18,
    x2: 165,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-11",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225,
    y1: 18,
    x2: 225,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-27",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.5,
    x2: 0.5,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-2",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 12,
    x2: 120,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 12,
    x2: 180,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-28",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "scale-viewer_svg__2",
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontSize: 10,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 11
  }, "2"))), /*#__PURE__*/React.createElement("g", {
    id: "scale-viewer_svg__\\u7F16\\u7EC4-15\\u5907\\u4EFD-3",
    transform: "translate(720.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 12,
    x2: 59,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-3",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: 18,
    x2: 74,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-6",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 18,
    x2: 135,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-9",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 18,
    x2: 195,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-24",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 18,
    x2: 29,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-4",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: 18,
    x2: 89,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-7",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 18,
    x2: 150,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-10",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 18,
    x2: 210,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-26",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 18,
    x2: 44,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-5",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 18,
    x2: 104,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 18,
    x2: 165,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-11",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225,
    y1: 18,
    x2: 225,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-27",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.5,
    x2: 0.5,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-2",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 12,
    x2: 120,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 12,
    x2: 180,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-28",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.5,
    y1: 2.5,
    x2: 239.5,
    y2: 30,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-8\\u5907\\u4EFD-29",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "scale-viewer_svg__4",
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontSize: 10,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 11
  }, "4")))), /*#__PURE__*/React.createElement("line", {
    x1: 1.13686838e-13,
    y1: 30.3748696,
    x2: 959.999967,
    y2: 30.6251304,
    id: "scale-viewer_svg__\\u8DEF\\u5F84-6",
    stroke: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleViewer);
export default __webpack_public_path__ + "static/media/scale-viewer.3e5bac9e.svg";
export { ForwardRef as ReactComponent };